import React from 'react'
import './MainContainer.css'

import About from '../About/About'
import Resume from '../Resume/Resume'
import Portfolio from '../Portfolio/Portfolio'
import Blog from '../Blog/Blog'
import Contact from '../Contact/Contact'

import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';

export default function MainContainer() {
    return (
        <div className='main-container'>
            <div className="main-container-top">
                <Router>
                    <div className="title-div">
                        <Routes>
                            <Route path='/' element={<About />}></Route>
                            <Route path='/Resume' element={<Resume />}></Route>
                            <Route path='/Portfolio' element={<Portfolio />}></Route>
                            <Route path='/Blog' element={<Blog />}></Route>
                            <Route path='/Contact' element={<Contact />}></Route>
                        </Routes>
                    </div>
                    <div className="nav-div">
                        <ul className='nav'>
                            <li className='navs'>
                                <NavLink to='/' end style={({ isActive }) => ({
                                    color: isActive ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none'
                                })}>
                                    About
                                </NavLink>
                            </li>
                            <li className='navs'>
                                <NavLink to='/Resume' style={({ isActive }) => ({
                                    color: isActive ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none'
                                })}>
                                    Resume
                                </NavLink>
                            </li>
                            <li className='navs'>
                                <NavLink to='/Portfolio' style={({ isActive }) => ({
                                    color: isActive ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none'
                                })}>
                                    Portfolio
                                </NavLink>
                            </li>
                            <li className='navs'>
                                <NavLink to='/Blog' style={({ isActive }) => ({
                                    color: isActive ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none'
                                })}>
                                    Blog
                                </NavLink>
                            </li>
                            <li className='navs'>
                                <NavLink to='/Contact' style={({ isActive }) => ({
                                    color: isActive ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none'
                                })}>
                                    Contact
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </Router>
            </div>
        </div>
    )
}
